import Packages from "../symbols/packages";

const initialState = {
  data: [],
  loading: false,
  error: false,
};

function PackagesReducer(state = initialState, action: any) {
  switch (action.type) {
    case Packages.PACKAGES:
      return { ...state, loading: true, error: false };
    case Packages.PACKAGES_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case Packages.PACKAGES_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case Packages.CLEAR_PACKAGES:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default PackagesReducer;
